import Constants from '@/utils/constants'

export const PRIVACY_POLICY_URL = 
  window.location.protocol + window.location.host + '/#/reservation/privacy-policy'

/* 'mens'版 */
export const MENS = 'mens'

/* 'womens'版 */
export const WOMENS = 'womens'

/* 'mens'版サービス名 */
export const SERVICE_NAME_MENS = 'Dクリニック'

/* 'womens'版サービス名 */
export const SERVICE_NAME_WOMENS = 'クレアージュ'

/* 'mens'版サイトURL */
export const URL_MENS = 'https://www.d-clinicgroup.jp/clinic/'

/* 'womens'版サイトURL */
export const URL_WOMENS = 'https://www.womenshealth-tokyo.com/'

/* 対象の性別：'mens','womens' */
// 'mens','womens'で変更する
export var TARGET = WOMENS

/* 'mens'版のエラーSVG */
export const CORORS_MENS = {
  formBgColor: '#dee8f5',
  formFontColor: '#102b55'
}

/* 'womens'版のエラーSVG */
export const CORORS_WOMENS = {
  formBgColor: '#f8f1ee',
  formFontColor: '#a77865'
}

/* 'mens'版か'womens'版かを判定する */
export const IsMens = () => {
  return TARGET === MENS
}

/* 'man'か'woman'を返却する */
export const getSex = () => {
  if (IsMens()) {
    return Constants.SexCategory.MAN
  } else {
    return Constants.SexCategory.WOMAN
  }
}

/* 公式サイトを返却する */
export const getURL = () => {
  if (IsMens()) {
    return URL_MENS
  } else {
    return URL_WOMENS
  }
}

/* サービス名を返却する */
export const getServiceName = () => {
  if (IsMens()) {
    return SERVICE_NAME_MENS
  } else {
    return SERVICE_NAME_WOMENS
  }
}

/* 使用するcolorを返却する */
export const getColors = () => {
  if (IsMens()) {
    return CORORS_MENS
  } else {
    return CORORS_WOMENS
  }
}
